import * as React from "react";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { useParams } from "react-router-dom";

import ClientBenefitPlanGrid from "./ClientBenefitPlanGrid";
import ClientContactsGrid from "./ClientContactsGrid";
import ClientRateMenuCompare from './ClientMenuCompare';
import ClientNotificationHistoryGrid from "./ClientNotificationHistoryGrid";
import ClientMenuFieldOverrideEditor from "./ClientMenuFieldOverrideEditor";
import ClientRateBandOverrideEditor from "./ClientRateBandOverrideEditor";
import ClientRateMenuGrid from "./ClientRateMenuGrid";
import ClientRateMenuGridLegacy from "./ClientRateMenuGridLegacy";
import ClientEmpMenuGrid from "./ClientEmpMenuGrid";
import OEContext from "../../layouts/OEContext";
import UserContext from "../../layouts/UserContext";

import { useQueryGetClients } from "../../data/services/clientService";

const ClientAdminLayout = () => {
  const { clientId } = useParams();
  const oePeriod = React.useContext(OEContext);
  const { loggedInUser } = React.useContext(UserContext);
  const isAdmin = Boolean(loggedInUser?.isAdmin);
  const isBam = Boolean(loggedInUser?.isBam);
  const canManageRateBandOverrides = isAdmin && !isBam;

  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
  const [client, setClient] = React.useState({});

  const { isLoading: clientListLoading, data: clientList } = useQueryGetClients(
    oePeriod?.oePeriodId,
    "No"
  );

  React.useEffect(() => {
    if (!clientListLoading && clientList && clientList.data) {
      let client = clientList.data.find((e) => e.clientId === clientId);
      setClient(client);
    }
  }, [clientListLoading, clientList, clientId]);

  const handleTabSelect = (e) => {
    setSelectedTabIndex(e.selected);
  };

  const titleText = client?.clientId && client?.clientName
    ? `${client.clientId} - ${client.clientName}`
    : clientId || "";

  return (
    <div>
      <div
        style={{
          justifyContent: "space-between",
          display: "flex",
          paddingBottom: 10,
        }}
      >
        <div>
          <h2>{titleText}</h2>
        </div>
        <div>
          <Button themeColor={"primary"} onClick={() => setSelectedTabIndex(5)}>
            Open Rate Menu Comparison
          </Button>
        </div>
      </div>
      <TabStrip selected={selectedTabIndex} onSelect={handleTabSelect}>
        <TabStripTab title="Benefit Plans">
          <ClientBenefitPlanGrid oePeriod={oePeriod} />
        </TabStripTab>
        <TabStripTab title="Contacts">
          <ClientContactsGrid />
        </TabStripTab>
        <TabStripTab title="Notification History">
          <ClientNotificationHistoryGrid />
        </TabStripTab>
        <TabStripTab title="Rate Menus">
          <ClientRateMenuGrid />
        </TabStripTab>
        <TabStripTab title="Rate Menus (Legacy)">
          <ClientRateMenuGridLegacy />
        </TabStripTab>
        <TabStripTab title="Rate Menu Comparison">
          <ClientRateMenuCompare />
        </TabStripTab>
        <TabStripTab title="Rate Employee Menus">
          <ClientEmpMenuGrid />
        </TabStripTab>
        <TabStripTab title="Menu Overrides">
          <ClientMenuFieldOverrideEditor />
        </TabStripTab>
        {canManageRateBandOverrides ? (
          <TabStripTab title="Rate Band Overrides">
            <ClientRateBandOverrideEditor />
          </TabStripTab>
        ) : null}
      </TabStrip>
    </div>
  );
};

export default ClientAdminLayout;
